import { Checkbox, Divider, Grid } from "@mui/material";
import type { GridRowSelectionModel } from "@mui/x-data-grid-premium";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import { messagesSelector } from "../../../store/state/messages/selectors";
import DownloadAllAction from "./desktop/messageActions/DownloadAllAction";
import MarkAsImportantAction from "./desktop/messageActions/MarkAsImportantAction";
import MarkAsNotImportantAction from "./desktop/messageActions/MarkAsNotImportantAction";

interface Props {
  selection: GridRowSelectionModel;
  showSelectAll?: boolean;
  compact?: boolean;
  setSelection: (selection: GridRowSelectionModel) => void;
}

export const Actions = (props: Props) => {
  const { selection, showSelectAll, compact, setSelection } = props;

  const messages = useSelector(messagesSelector);

  const changeSelection = useCallback(() => {
    if (selection.ids.size === 0) {
      setSelection({ type: "include", ids: new Set(messages.map((m) => m.id)) });
    } else {
      setSelection({ type: "include", ids: new Set() });
    }
  }, [messages, selection.ids.size, setSelection]);

  return (
    <Grid
      container
      spacing={1}
      sx={{ width: "100%", alignItems: "center", justifyContent: compact ? "center" : "inherit" }}
    >
      {showSelectAll && messages && messages.length > 0 && (
        <Checkbox checked={selection.ids.size > 0} onChange={() => changeSelection()} />
      )}
      {!compact && selection.ids.size > 0 && <Divider orientation="vertical" flexItem sx={{ my: 1 }} />}
      <Grid>
        <DownloadAllAction compact={compact} selection={selection} />
      </Grid>
      <Grid>
        <MarkAsImportantAction compact={compact} selection={selection} />
      </Grid>
      <Grid>
        <MarkAsNotImportantAction compact={compact} selection={selection} />
      </Grid>
    </Grid>
  );
};

export default Actions;
